
/**
 * @param {TrackingAnalytics} analytics
 */
function CatalogFacetTracker(analytics) {

    this.analytics = analytics;
    this.$facets = $('.facet');
    this.blocking = true;
}

CatalogFacetTracker.prototype = {

    init() {

        if (!this.$facets.length) {
            return;
        }

        this.$facets.each(this.initFacetTracking.bind(this));
    },

    /**
     * @param  {Object} $select
     * @param  {String} label
     * @return {CatalogFacetTracker}
     */
    initSelectTracking($select, label) {
        $select.on('change', this.trackSelect.bind(this, $select, label));
        return this;
    },

    /**
     * @param  {Object} $select
     * @param  {String} label
     * @return {CatalogFacetTracker}
     */
    initSliderTracking($slider, label) {
        $slider.on('change', this.trackSlider.bind(this, $slider, label));
        return this;
    },

    /**
     * @param  {Number} index
     * @param  {Node} element
     * @return {CatalogFacetTracker}
     */
    initFacetTracking(index, element) {
        var $facet, $input;

        $facet = $(element);
        $input = $facet.find('select');

        if ($input.length) {
            return this.initSelectTracking($input, $facet.find('.facet__label').text());
        }

        $input = $facet.find('.range-slider');

        if ($input.length) {
            return this.initSliderTracking($input, $facet.find('.facet__label').text());
        }

        return this;
    },

    /**
     * @param  {Object} $select
     * @param  {String} label
     * @param  {Object} event
     * @return {Boolean}
     */
    trackSelect($select, label, event) {
        if (!this.blocking) {
            return true;
        }

        event.preventDefault();
        this.blocking = false;

        this.analytics.trackWithCallback(
            {
                eventName: 'Facet Select',
                eventBody: {
                    event_category: 'Selection',
                    event_label: label,
                    value: $select.val()
                }
            },
            $select.trigger.bind($select, 'change')

        );

        return false;
    },

    /**
     * @param  {Object} $slider
     * @param  {String} label
     * @param  {Object} event
     * @return {Boolean}
     */
    trackSlider($slider, label, event) {
        if (!this.blocking) {
            return true;
        }

        event.preventDefault();
        this.blocking = false;

        this.analytics.trackWithCallback(
            {
                eventName: 'Facet Select',
                eventBody: {
                    event_category: 'Selection',
                    event_label: label,
                    value: JSON.stringify($slider.val())
                }
            },
            $slider.trigger.bind($slider, 'change')

        );

        return false;
    }
};

export default CatalogFacetTracker;